module.exports = __webpack_public_path__ + "images/category_lp/common/medal_ba11c3455b56108190661551b249471e.png";